import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  getUserOutstandingBalance,
  GetUserOutstandingBalanceOptions,
  UserOutstandingBalance,
} from 'api/payments'
import { paymentKeys } from './keys'

type UseUserOutstandingBalanceQueryKey = ReturnType<
  typeof paymentKeys.outstandingBalanceDetail
>

/**
 * Get the outstanding balance for a user
 * @example useUserOutstandingBalance({ userId: 123 }, { retry: true })
 */
export function useUserOutstandingBalance(
  /** Pass through to API */
  filters: GetUserOutstandingBalanceOptions,
  /** useQuery options */
  options?: Pick<
    Parameters<
      typeof useQuery<
        UserOutstandingBalance,
        Error,
        UserOutstandingBalance,
        UseUserOutstandingBalanceQueryKey
      >
    >[0],
    'retry' | 'initialData' | 'enabled'
  >
): UseQueryResult<UserOutstandingBalance> {
  return useQuery({
    queryKey: paymentKeys.outstandingBalanceDetail(filters.userId),
    queryFn: async () => getUserOutstandingBalance(filters),
    retry: false,
    ...options,
  })
}
